import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Age = (props) => {
  return (
    <FormGroup controlId="age">
      <Col componentClass={ControlLabel} sm={5}>
        Age
      </Col>
      <Col sm={7}>
        <select
          className="custom-select"
          name="age"
          onChange={props.handleChangeAge}
          value={props.age}
        >
          <option value="">Please select</option>
          <option value="25-65">25-65</option>
          <option value="Others">Others</option>
        </select>
      </Col>
    </FormGroup>
  )
}

Age.propTypes = {
  age: PropTypes.string,
  handleChangeAge: PropTypes.func
};

export default Age;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/age/Age.js